import { BiTrackService } from '@eureka/domains/src/bi-track/services/bi-track-service';
import { injectService } from '@patsnap/tahiti-core';
import { createSharedComposable } from '@vueuse/core';
import { ref } from 'vue';
import { getBrowserFingerprint } from '@patsnap-utils/browser-fingerprint';
import { InitCookie } from '@patsnap/init-cookie';

export const useTracking = createSharedComposable(() => {
  const source = ref('');

  const setTrackSource = (s: string) => {
    source.value = s;
  };

  const sendTracking = async (eventName: string, s?: string, others?: Record<any, any>) => {
    const biTrackService = injectService<BiTrackService>(BiTrackService);
    const fingerprint = (await getBrowserFingerprint()) as unknown as string;

    let sourceType = '';

    if (s) {
      sourceType = s;
    } else {
      sourceType = source.value;
    }

    biTrackService.biTrack(eventName, {
      sourceType,
      eventDetailStr: {
        ...others,
        agentSource:
          source.value === 'MSE_HOME_PAGE' || source.value === 'MSE_LANDING_PAGE'
            ? 'mse_home'
            : 'mse_detail_page',
        signatureId: fingerprint,
        campaignName: InitCookie.getCampaignName(),
      },
    });
  };

  const sendLandingPageTracking = async () => {
    const biTrackService = injectService<BiTrackService>(BiTrackService);
    const fingerprint = (await getBrowserFingerprint()) as unknown as string;

    biTrackService.biTrack('SS PLG PAGE VIEW', {
      sourceType: 'mse_home',
      eventDetailStr: {
        signatureId: fingerprint,
        campaignName: InitCookie.getCampaignName(),
      },
    });
  };

  return {
    setTrackSource,
    sendTracking,
    sendLandingPageTracking,
  };
});
